export let PreBuiltCartType = /*#__PURE__*/function (PreBuiltCartType) {
  PreBuiltCartType["PreBuiltRegular"] = "PRE_BUILT_REGULAR";
  PreBuiltCartType["PreBuiltLimited"] = "PRE_BUILT_LIMITED";
  return PreBuiltCartType;
}({});
export const PRE_BUILT_CART_LABEL = {
  [PreBuiltCartType.PreBuiltRegular]: 'Regular',
  [PreBuiltCartType.PreBuiltLimited]: 'Limited'
};